export const segments = [
  {
    segment: 'fitment-details',
    name: 'fitmentDetails',
    title: 'Fitment details',
    circleIcon: false,
    active: true,
  },
];
